import { redactSensitive } from '../security/redactSensitive';

const API_URL = process.env.REACT_APP_API_URL;
const IS_PROD = process.env.NODE_ENV === 'production';

// Çağıran fonksiyonu tespit etme
const getCallingFunction = () => {
  try {
    const stack = new Error().stack;
    const lines = stack.split('\n');
    
    // fetchWrapper'ı atla, gerçek çağıranı bul
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (line.includes('fetchWrapper') || line.includes('enhancedFetchWrapper')) {
        continue;
      }
      
      // React component veya fonksiyon adını bul
      const match = line.match(/at\s+(\w+)/);
      if (match && match[1] && match[1] !== 'Error') {
        return match[1];
      }
      
      // Daha detaylı pattern
      const detailedMatch = line.match(/at\s+(\w+\.?\w*)/);
      if (detailedMatch && detailedMatch[1]) {
        return detailedMatch[1];
      }
    }
    
    return 'Unknown';
  } catch (error) {
    return 'Error Detecting Function';
  }
};

export const fetchWrapper = async (process, bodyParams, navigate) => {
  const callingFunction = getCallingFunction();
  const requestId = Date.now() + Math.random();
  
  // Request bilgilerini hazırla
  let requestBody = {};
  if (bodyParams instanceof FormData) {
    // FormData'dan değerleri çıkar
    for (let [key, value] of bodyParams.entries()) {
      if (key === 'EVEFILE[]') continue; // Dosyaları atla
      requestBody[key] = value;
    }
  } else {
    requestBody = bodyParams;
  }
  
  let options = {
    method: 'POST',
  }; 
  
  // Eğer bodyParams FormData ise, 'process' parametresini FormData'ya ekleyin
  if (bodyParams instanceof FormData) {
    bodyParams.append('process', process);
    options.body = bodyParams;
  } else {
    // FormData değilse, JSON formatında gönderim yapıyoruz
    options.headers = {
      'Content-Type': 'application/json',
    };
    const requestBodyForSend = {
      ...bodyParams,
      process,
    };
    options.body = JSON.stringify(requestBodyForSend);
  }

  try {
    const startTime = performance.now();
    
    const response = await fetch(API_URL, options);
    const responseText = await response.text();
    
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (parseError) {
      // PHP error mı kontrol et
      if (responseText.includes('<b>Fatal error</b>') || responseText.includes('<b>Parse error</b>')) {
        const errorMatch = responseText.match(/<b>(.*?)<\/b>/g);
        const errorText = errorMatch ? errorMatch.map(m => m.replace(/<\/?b>/g, '')).join(' ') : 'PHP Error';
        console.error('Backend PHP Error:', errorText);
        throw new Error(`Backend PHP Error: ${errorText}`);
      }
      
      // PHP Warning temizleme (geçici çözüm)
      if (responseText.includes('<b>Warning</b>') || responseText.includes('<br />')) {
        console.warn('⚠️ PHP Warning tespit edildi, JSON temizleniyor...');
        // PHP warning'lerini kaldır - { karakterinden itibaren JSON'u al
        const jsonStart = responseText.indexOf('{');
        if (jsonStart !== -1) {
          const cleanedText = responseText.substring(jsonStart);
          try {
            responseData = JSON.parse(cleanedText);
            console.warn('✅ JSON başarıyla temizlendi ve parse edildi');
            console.warn('📋 PHP Warning içeriği:', responseText.substring(0, jsonStart));
          } catch (retryError) {
            if (!IS_PROD) {
              console.error('JSON Parse Error (retry failed):', retryError.message);
            }
            const snippet = IS_PROD ? '' : ` Response: ${responseText.substring(0, 200)}`;
            throw new Error(`JSON parse hatası: ${retryError.message}.${snippet}`);
          }
        } else {
          if (!IS_PROD) {
            console.error('JSON Parse Error: JSON bulunamadı');
          }
          const snippet = IS_PROD ? '' : ` Response: ${responseText.substring(0, 200)}`;
          throw new Error(`JSON parse hatası: JSON başlangıcı bulunamadı.${snippet}`);
        }
      } else {
        if (!IS_PROD) {
          console.error('JSON Parse Error:', parseError.message);
        }
        const snippet = IS_PROD ? '' : ` Response: ${responseText.substring(0, 200)}`;
        throw new Error(`JSON parse hatası: ${parseError.message}.${snippet}`);
      }
    }
    
    const endTime = performance.now();
    const duration = endTime - startTime;

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    // Debug log ekle (eğer debug context varsa)
    try {
      if (!IS_PROD && window.debugContext && typeof window.debugContext.addDebugLog === 'function') {
        window.debugContext.addDebugLog({
          type: 'REQUEST',
          processId: process,
          callingFunction,
          requestBody: redactSensitive(requestBody),
          responseData: redactSensitive(responseData),
          duration: `${duration.toFixed(2)}ms`,
          hasDebugDiagrun: !!responseData.debug_diagrun,
          debugDiagrun: responseData.debug_diagrun || null,
          requestId
        });
      }
    } catch (error) {
      // Silent fail
    }

    // Eğer token geçersizse veya bulunamazsa login ekranına yönlendirme
    if (responseData.token_return === "false") {
      localStorage.removeItem('token');
      navigate('/login');
    }

    return responseData;
  } catch (error) {
    // Debug log ekle (hata durumu)
    try {
      if (!IS_PROD && window.debugContext && typeof window.debugContext.addDebugLog === 'function') {
        window.debugContext.addDebugLog({
          type: 'ERROR',
          processId: process,
          callingFunction,
          requestBody: redactSensitive(requestBody),
          error: error.message,
          requestId
        });
      }
    } catch (logError) {
      if (!IS_PROD) {
        console.warn('Debug log ekleme hatası:', logError);
      }
    }
    throw error;  // Hata bir üst katmana iletilir
  }
};